import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Input.css';

export function InputText(props){
    return(
        <div className='input__container'>
            <label htmlFor={ props.id }>{ props.placeholder } </label> 
            <input type={props.type ? props.type : 'text'} name={props.name} disabled={ props.disabled ? true: false } placeholder={props.placeholder} defaultValue={props.value ? props.value : ''} onChange={props.onChange}/>
        </div>
        
    );
}

function InputLogo(props){
    return(
        <div className={`input-logo__container`}>
            <label htmlFor={ props.name }>
                <p>{ props.placeholder }</p>
                <div className='input-logo'>
                    { props.icon ? 
                    <div className='icon-container'><FontAwesomeIcon icon={ props.icon } size='lg'/></div>
                    : null }
                    <input type={ props.type } name={ props.name } id={ props.name } placeholder={ props.placeholder } />
                </div>
            </label>
        </div>
    );
}

function TextArea(props){
    return(
        <div className='input__container'>
            <label htmlFor={ props.id }>{ props.label ? props.label : props.placeholder } </label> 
            <textarea type='text' name={props.name} disabled={ props.disabled ? true: false } placeholder={props.placeholder} defaultValue={props.value ? props.value : ''} onChange={props.onChange}/>
        </div>
        
    );
}

export function Switch(props){
    // console.log(props);
    console.log(props.checked);
    return(
        <label className='switch rounded-full flex flex-row items-center p-2'>
            <input type='checkbox' className='hidden' name={props.name} onChange={props.onChange} checked={ props.checked } />
            <div className='slider rounded-full shadow-lg'></div>
            <style>
            {
                `
                    .switch{
                        border-radius: 9999px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        padding: 2px;
                    }

                    .switch:hover{
                        cursor: pointer;
                    }
                    .slider{
                        display: inline-block;
                        width: 80px;
                        height: 30px;
                        background: #BDBDBD;
                        position: relative;
                        border-radius: 9999px;
                        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
                    }
                    .slider:after{
                        content: '';
                        background: #F2F2F2;
                        position: absolute;
                        display: block;
                        width: 36px;
                        height: 36px;
                        top: -3px;
                        left: 0;
                        transition: all ease 0.2s;
                        border-radius: 999px;
                    }
                    input:checked + .slider{
                        background-color: #ED2D98;
                    }
                    input:checked + .slider:after{
                        -webkit-transform: translateX(44px);
                        -ms-transform: translateX(44px);
                        transform: translateX(44px);
                    }
                `
            }
            </style>

        </label>
    );
}

export { InputLogo, TextArea };